import _ from 'lodash';

// Retrieve the homeowners LOB path
const getHOLOBPath = (jobVM) => {
  return _.get(jobVM, 'lobData.homeowners.value') ? 'lobData.homeowners' : 'lobData.homeowners_tfpa';
};

// Retrieve the homeowners LOB
const getHOLOB = (jobVM) => {
  return _.get(jobVM, `${getHOLOBPath(jobVM)}`);
};

export {
    getHOLOBPath as getHOLOBPath,
    getHOLOB as getHOLOB
};
